<template>
  <el-dialog
    title="快递编辑"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="200px"
      size="small"
    >

      <el-form-item
              prop="express_name"
              label="快递名称"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.express_name"></el-input>
      </el-form-item>

      <el-form-item
              prop="express_no"
              label="快递单号"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.express_no"></el-input>
      </el-form-item>

      <el-form-item  v-if="formEdit">
        <el-button
          type="primary"
          :loading="loading"
          @click="saveUser"
        >提交</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<script>
import * as agentService from '@/api/sys/agent'
import * as oneclassService from '@/api/sys/oneclass'
import util from '@/libs/util.js'
export default {
  name: 'smallposterEditForm',
  props: {
    oneclass: Object,
    value: Boolean
  },
  data () {
    return {

      formEdit: true,
      loading: false,
      dialogVisible: false,
      form: {
        express_name: '',
        express_no: ''
      }
    }
  },
  watch: {
    value (val) {
      this.dialogVisible = val
    },
    dialogVisible (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    dialogOpen () {
      this.$refs.form.resetFields()
      if (this.oneclass.express_name != '' && this.oneclass.express_name != null) {
        this.form.express_name = this.oneclass.express_name
      }
      if (this.oneclass.express_no != '' && this.oneclass.express_no != null) {
        this.form.express_no = this.oneclass.express_no
      }
    },

    saveUser () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loading = true
          agentService.IntegralordeExpress({ ...this.form, order_no: this.oneclass.order_id })
            .then(data => {
              this.loading = false
              this.dialogVisible = false
              this.$emit('submit')
            })
        } else {
          return false
        }
      })
    },
    close () {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    }
  }
}
</script>
